import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getPurchaseTypesByDossierSubType from '../../services/purchaseType/getPurchaseTypesByDossierSubType'
import { showLoader, hideLoader } from '../../actions/common.js'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchPurchaseTypeSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchPurchaseType ({ dossierSubTypeId }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    let combo = []
    if (dossierSubTypeId) {
      combo = yield call(getPurchaseTypesByDossierSubType, auth.token, dossierSubTypeId)
    }
    yield put(fetchPurchaseTypeSuccess(combo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchPurchaseType () {
  yield takeLatest(combosActionTypes.FETCH_PURCHASE_TYPE, fetchPurchaseType)
}
